export const HIRE_ONBOARDING_PROGRESS_STEPS = [
  "Analyzing website",
  "Building organization profile",
  "Finding locations",
  "Finding departments",
  "Setting up AI Employee goals & channels",
  "Configuring recommended tools",
  "Generating AI Employee preview",
  "Sign Up | Create SiteGlue Account",
] as const;

/** SiteGlue Trish consultant steps → progress checklist index. */
export function resolveHireOnboardingProgressStepIndex(input: {
  step?: string | null;
  isBootstrapping?: boolean;
  isBuildingCompanyProfile?: boolean;
  isGeneratingPreview?: boolean;
  hasCompanyProfile?: boolean;
  hasLocations?: boolean;
  previewGenerated?: boolean;
  isSignedIn?: boolean;
}): number {
  const signupIdx = HIRE_ONBOARDING_PROGRESS_STEPS.length - 1;
  const generateIdx = signupIdx - 1;

  if (input.previewGenerated) {
    if (input.isSignedIn) return HIRE_ONBOARDING_PROGRESS_STEPS.length;
    return signupIdx;
  }
  if (input.isGeneratingPreview) return generateIdx;
  const step = (input.step ?? "").trim();
  if (input.isBootstrapping || step === "analyzing" || step === "website") return 0;
  if (input.isBuildingCompanyProfile || step === "building_knowledge") {
    if (input.hasCompanyProfile && input.hasLocations) return 3;
    if (input.hasCompanyProfile) return 2;
    return 1;
  }
  if (
    step === "snapshot" ||
    step === "goals" ||
    step === "report_draft" ||
    step === "meet_employee" ||
    step === "agent_profile" ||
    step === "agent_job_title"
  ) {
    return input.hasLocations ? 4 : 3;
  }
  if (step === "sign_up") return signupIdx;
  if (step === "complete") return HIRE_ONBOARDING_PROGRESS_STEPS.length;
  return input.hasCompanyProfile ? 2 : 0;
}

/** Index of the "Generating AI Employee preview" step. */
export const HIRE_ONBOARDING_GENERATE_STEP_INDEX = HIRE_ONBOARDING_PROGRESS_STEPS.length - 2;

/** Index of the Sign Up step (after preview generation). */
export const HIRE_ONBOARDING_SIGNUP_STEP_INDEX = HIRE_ONBOARDING_PROGRESS_STEPS.length - 1;

export type HireOnboardingProgressStepId = (typeof HIRE_ONBOARDING_PROGRESS_STEPS)[number];

export function delayMs(ms: number): Promise<void> {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

/** Advance through post-analysis setup steps with short pauses for readable progress UI. */
export async function animatePostAnalysisProgressSteps(
  onStep: (index: number) => void,
  fromIndex = 1,
  toIndex = 5,
  pauseMs = 380,
): Promise<void> {
  for (let i = fromIndex; i <= toIndex; i++) {
    onStep(i);
    await delayMs(pauseMs);
  }
}
